import { Brick, registerBrick } from 'olympe';
import {getLogger} from '@olympeio/core';
import { performGetFromJSON, processResults } from './helpers';

// noinspection JSUnusedGlobalSymbols
export default class GetFromJSONCustom extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} source
     * @param {string} path
     * @param {function(*)} setResult
     * @param {function(*)} setErrorFlow
     */
    update($, [source, path], [setResult, setErrorFlow]) {
        const logger = getLogger('Get From JSON');

        // Guards
        if (typeof source !== 'object' && typeof source !== 'string') {
            logger.error('Provided source is not object or string');
            return;
        }
        if (typeof path !== 'string') {
            logger.error('Provided path is not a string');
            return;
        }

        performGetFromJSON(source, path, setErrorFlow, (results) => {
            processResults(results, logger, setResult);
        });
    }
}

registerBrick('018a212c3b0dae7e2988', GetFromJSONCustom);
